import { render, staticRenderFns } from "./inactiveText-editor.vue?vue&type=template&id=3ce7db57&scoped=true"
import script from "./inactiveText-editor.vue?vue&type=script&lang=js"
export * from "./inactiveText-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce7db57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ce7db57')) {
      api.createRecord('3ce7db57', component.options)
    } else {
      api.reload('3ce7db57', component.options)
    }
    module.hot.accept("./inactiveText-editor.vue?vue&type=template&id=3ce7db57&scoped=true", function () {
      api.rerender('3ce7db57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-switch/inactiveText-editor.vue"
export default component.exports